// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <v-container fluid grid-list-xs>
    <v-card>
      <v-toolbar flat class="card-header">
        <v-btn icon @click="exit"><v-icon>arrow_back</v-icon></v-btn>
          <span class="title">{{ formatDateTime(this.metadata.timestamp) }} </span> - {{ this.metadata.annotation }} - {{ this.metadata.tags }}
        <v-spacer></v-spacer>
        <a :href="downloadLink" :download="downloadName" style="text-decoration: none;">
          <v-btn depressed color="success" class="mx-1">Download</v-btn>
          </a>
        <v-btn depressed color="error" class="mx-1" @click.stop="showDeleteDialog = true">Delete</v-btn>
      </v-toolbar>
      <v-card-text style="white-space: pre-wrap;">
        {{ file }}
      </v-card-text>
    </v-card>

    <v-dialog v-model="showDeleteDialog" max-width="500px">
      <v-card>
        <v-card-title>
          <div class="headline">Delete Log?</div>
        </v-card-title>
        <v-card-text>Are you sure you want to delete this log?  This action cannot be undone.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click.native="showDeleteDialog = false">Cancel</v-btn>
          <v-btn text color="error" @click.native="deleteFile">I'm Sure</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>

<script>
import moment from 'moment'
import { ENDPOINT } from '@/shared/constants'
import ApiRequests from '@/api/ApiRequests'

export default {
  data () {
    return {
      file: '',
      metadata: {},
      showDeleteDialog: false
    }
  },

  created () {
    ApiRequests.logGet(this.$route.params.id).then(response => {
      this.file = response.data
    })

    ApiRequests.logGetMeta(this.$route.params.id).then(response => {
      this.metadata = response.data
    })
  },

  computed: {
    downloadLink: function () {
      return ENDPOINT + 'logs/' + this.$route.params.id
    },

    downloadName: function () {
      var name = 'log_'
      if (this.metadata.tags) {
        if (this.metadata.tags[0]) {
          name = name + this.metadata.tags[0] + '_'
        }
      }
      name = name + moment(this.metadata.timestamp).format('YYYYMMDDHHmm') + '.log'
      return name
    }
  },

  methods: {
    deleteFile: function () {
      ApiRequests.logDelete(this.$route.params.id).then(() => {
        this.exit()
      })
    },

    exit: function () {
      this.$router.go(-1)
    }
  }

}
</script>
